import { render, staticRenderFns } from "./contract.vue?vue&type=template&id=a588b42c&scoped=true"
import script from "./contract.vue?vue&type=script&lang=js"
export * from "./contract.vue?vue&type=script&lang=js"
import style0 from "./contract.vue?vue&type=style&index=0&id=a588b42c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a588b42c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\iotcarduserui\\iotcardpc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a588b42c')) {
      api.createRecord('a588b42c', component.options)
    } else {
      api.reload('a588b42c', component.options)
    }
    module.hot.accept("./contract.vue?vue&type=template&id=a588b42c&scoped=true", function () {
      api.rerender('a588b42c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/home/component/contract.vue"
export default component.exports